// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__12mlS","productName":"Table_productName__1OL-3"};